import { graphql, useStaticQuery } from 'gatsby';

export default function useSitePluginI18n() {
    const { sitePlugin } = useStaticQuery(graphql`
    {
        sitePlugin(name: {eq: "gatsby-plugin-i18n-l10n"}) {
            pluginOptions
        }
    }
`);

    return sitePlugin;
}
